import {Label} from '@mui/icons-material'
import {style, width} from '@mui/system'
import dayjs from 'dayjs'

export const NEW_RECORD_INPUTS = [
  {sectionHeading: 'Vital Signs', rowNumber: 5},
  {
    label: 'Blood Pressure',
    name: 'bp',
    type: 'text',
    // required: true,
    rowNumber: 6,
  },
  {
    label: 'Pulse',
    name: 'pulse',
    type: 'text',
    // required: true,
    rowNumber: 6,
  },
  {
    label: 'Respiratory Rate',
    name: 'rr',
    type: 'text',
    // required: true,
    rowNumber: 6,
  },
  {
    label: 'Temperature',
    name: 'temp',
    type: 'text',
    // required: true,
    rowNumber: 7,
  },
  {
    label: 'O2 Saturation',
    name: 'o2sat',
    type: 'text',
    // required: true,
    rowNumber: 7,
  },
  {
    label: 'Pain Scale',
    name: 'pain',
    type: 'text',
    // required: true,
    rowNumber: 7,
  },

  {sectionHeading: 'Assessment', rowNumber: 9},
  {
    label: 'Neuro',
    name: 'neuro',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 9,
  },
  {
    label: 'Skin',
    name: 'skin',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 9,
  },
  {
    label: 'HEENT',
    name: 'heent',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 10,
  },

  {
    label: 'Respiratory',
    name: 'respiratory',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 11,
  },
  {
    label: 'Cardiac',
    name: 'cardiac',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 11,
  },

  {sectionHeading: 'GI', rowNumber: 14},

  {
    label: 'Last BM',
    name: 'lastBm',
    type: 'number',
    // required: true,
    rowNumber: 15,
  },
  {
    label: 'Weight(lbs)',
    name: 'value',
    type: 'number',
    rowNumber: 15,
  },
  {
    label: 'Type',
    name: 'type',
    type: 'select',
    options: [
      {label: 'Gain', value: 'gain'},
      {label: 'Loss', value: 'loss'},
    ],
    // required: true,
    rowNumber: 15,
  },
  {
    label: 'GU (Genitourinary)',
    name: 'gu',
    type: 'text',
    rowNumber: 17,
  },

  {sectionHeading: 'Visit Notes', rowNumber: 18},

  {
    label: 'Patient Concerns',
    name: 'patientConcerns',
    type: 'textarea',
    // required: true,
    minRows: 4,
    rowNumber: 19,
  },
  {
    label: 'Notes',
    name: 'notes',
    type: 'textarea',
    // required: true,
    minRows: 4,
    rowNumber: 19,
  },
  {
    label: 'DME',
    name: 'dme',
    type: 'textarea',
    // required: true,
    minRows: 2,
    rowNumber: 20,
  },

  {
    sectionHeading: 'Next Visit',
    rowNumber: 25,
  },
  {
    // label: 'Next Appt',
    name: 'nextAppt',
    type: 'date',
    minDate: dayjs().toDate(),
    readOnly: true,
    // required: true,
    rowNumber: 26,
  },
]

export const EDIT_RECORD_INPUTS = [
  // {sectionHeading: 'Note Type', rowNumber: 1},
  //   {
  //   noteType: true,
  //   isTemplate: false,
  //   rowNumber: 2,
  //   isEntry: false,
  //   isFullForm: true,
  //   isEdit: true
  // },
  {sectionHeading: 'Vital Signs', rowNumber: 5},
  {
    label: 'Blood Pressure',
    name: 'bp',
    type: 'text',
    // required: true,
    rowNumber: 6,
  },
  {
    label: 'Pulse',
    name: 'pulse',
    type: 'text',
    // required: true,
    rowNumber: 6,
  },
  {
    label: 'Respiratory Rate',
    name: 'rr',
    type: 'text',
    // required: true,
    rowNumber: 6,
  },
  {
    label: 'Temperature',
    name: 'temp',
    type: 'text',
    // required: true,
    rowNumber: 7,
  },
  {
    label: 'O2 Saturation',
    name: 'o2sat',
    type: 'text',
    // required: true,
    rowNumber: 7,
  },
  {
    label: 'Pain Scale',
    name: 'pain',
    type: 'text',
    // required: true,
    rowNumber: 7,
  },

  {sectionHeading: 'Assessment', rowNumber: 9},
  {
    label: 'Neuro',
    name: 'neuro',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 9,
  },
  {
    label: 'Skin',
    name: 'skin',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 9,
  },
  {
    label: 'HEENT',
    name: 'heent',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 10,
  },

  {
    label: 'Respiratory',
    name: 'respiratory',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 11,
  },
  {
    label: 'Cardiac',
    name: 'cardiac',
    type: 'textarea',
    // required: true,
    minRows: 3,
    rowNumber: 11,
  },

  {sectionHeading: 'GI', rowNumber: 14},

  {
    label: 'Last BM',
    name: 'lastBm',
    type: 'number',
    // required: true,
    rowNumber: 15,
  },
  {
    label: 'Weight(lbs)',
    name: 'value',
    type: 'number',
    rowNumber: 15,
  },
  {
    label: 'Type',
    name: 'type',
    type: 'select',
    options: [
      {label: 'Gain', value: 'gain'},
      {label: 'Loss', value: 'loss'},
    ],
    // required: true,
    rowNumber: 15,
  },
  {
    label: 'GU (Genitourinary)',
    name: 'gu',
    type: 'text',
    rowNumber: 17,
  },

  {sectionHeading: 'Visit Notes', rowNumber: 18},

  {
    label: 'Patient Concerns',
    name: 'patientConcerns',
    type: 'textarea',
    // required: true,
    minRows: 4,
    rowNumber: 19,
  },
  {
    label: 'Notes',
    name: 'notes',
    type: 'textarea',
    // required: true,
    minRows: 4,
    rowNumber: 19,
  },
  {
    label: 'DME',
    name: 'dme',
    type: 'textarea',
    // required: true,
    minRows: 2,
    rowNumber: 20,
  },

  {
    sectionHeading: 'Next Visit',
    rowNumber: 25,
  },
  {
    // label: 'Next Appt',
    name: 'nextAppt',
    type: 'date',
    minDate: dayjs().toDate(),
    readOnly: true,
    // required: true,
    rowNumber: 26,
  },
]

export const NEW_RECORD_FORM_INPUTS = {
  bp: '',
  pulse: '',
  rr: '',
  temp: '',
  o2sat: '',
  pain: '',
  therapy: [],
  neuro: '',
  skin: '',
  heent: '',
  respiratory: '',
  cardiac: '',
  falls: '',
  mobility: '',
  lastBm: '',
  value: '',
  select: '',
  gu: '',
  patientConcerns: '',
  notes: '',
  dme: '',
  medRec: '',
  pocUpdated: '',
  familyUpdated: '',
  nextAppt: '',
  startDate: '',
  noteType: '',
}

export const NEW_NURSES_ASSESSMENT_INPUTS = [
  {sectionHeading: 'Pain Assessment:', rowNumber: 204},
  {
    type: 'NursesAssessmentDialog',
    rowNumber: 205,
  },
  {sectionHeading: 'Pain Scale:', rowNumber: 206},
  {
    name: 'painScale',
    type: 'radio',
    options: [
      {label: '1', value: '1'},
      {label: '2', value: '2'},
      {label: '3', value: '3'},
      {label: '4', value: '4'},
      {label: '5', value: '5'},
      {label: '6', value: '6'},
      {label: '7', value: '7'},
      {label: '8', value: '8'},
      {label: '9', value: '9'},
      {label: '10', value: '10'},
    ],
    required: false,
    rowNumber: 206,
  },
  {sectionHeading: 'Fall Risk:', rowNumber: 208},
  {
    label: 'Two or more falls or fall with injury within 1 year?',
    name: 'fallWithinYear',
    type: 'select',
    options: [
      {label: 'Yes', value: 'true'},
      {label: 'No', value: 'false'},
    ],
    required: false,
    rowNumber: 209,
  },
  {
    label: 'Currently on Fall Precautions',
    name: 'currentlyonFallPrecaution',
    type: 'select',
    options: [
      {label: 'Yes', value: 'true'},
      {label: 'No', value: 'false'},
    ],
    required: false,
    rowNumber: 209,
  },
  {
    type: 'VascularAccessDialog',
    rowNumber: 210,
  },
]

export const NEW_NURSES_ASSESSMENT_FORM_INPUTS = {
  painAsessment: [],
  painScale: '',
  fallWithinYear: '',
  currentlyonFallPrecaution: '',
  vascularAcess: [],
}

// NursesAssessmentForm1 fields and initial state
export interface NursesAssessmentForm1Fields {
  clientId: string
  assessmentDate: string
  allergies: string[]
  otherAllergies: string
  codeStatus: string
  infoSource: string
  otherInfoSource: string
  precautions: string
  otherPrecautions: string
  t: string
  r: string
  p: string
  bp: string
  height: string
  weight: string
  medications: string[]
  wounds: string
  alternativeNutrition: string
  weightdetails: string
  weightamount: string
  dietaryDetails: string[]
}

export const NURSES_ASSESSMENT_FORM1_INITIAL_STATE: NursesAssessmentForm1Fields = {
  clientId: '',
  assessmentDate: '',
  allergies: [],
  otherAllergies: '',
  codeStatus: '',
  infoSource: '',
  otherInfoSource: '',
  precautions: '',
  otherPrecautions: '',
  t: '',
  r: '',
  p: '',
  bp: '',
  height: '',
  weight: '',
  medications: [],
  wounds: '',
  alternativeNutrition: '',
  weightdetails: '',
  weightamount: '',
  dietaryDetails: [],
}
// NursesAssessmentForm2 interface and initial state
export interface NursesAssessmentForm2Fields {
  leisureInterest: string[]
  socialActivities: string
  copingSkills: string
  culturalPractices: string
  spiritualPractices: string
  otherPsychosocial: string
  abuseHistory: string
  selfHarm: string
  etohConsumption: string
  drugAbuse: string
  caffeineIntake: string
  tobaccoUse: string
  cessationEducation: string
  medicalHistory: string[]
  lastFluVaccine: string
  lastPneumoniaVaccine: string
  prevSurgeries: string
  patientTB: string
  familyTB: string
  followingSymptoms: string
  bloodTransfusion: string
  transfusionReactionDetails: string
  diabetic: string
  diabeticYears: string
  diabeticTreatment: string
  glucometer: string
  fingerStick: string
  administerInsulin: string
  interpreterNeeded: string
  preferredLanguage: string
  familyCareInvolved: string
  familyAvailforTeaching: string
  educationalNeeds: string
  response: string
  motorResponse: string
  verbalResponse: string
  affect: string
  otherAffect: string
  hearing: string
  vision: string
  gagReflex: string
  speech: string
  prevSurgeriesDetails: string
}

export const NURSES_ASSESSMENT_FORM2_INITIAL_STATE: NursesAssessmentForm2Fields = {
  leisureInterest: [],
  socialActivities: '',
  copingSkills: '',
  culturalPractices: '',
  spiritualPractices: '',
  otherPsychosocial: '',
  abuseHistory: '',
  selfHarm: '',
  etohConsumption: '',
  drugAbuse: '',
  caffeineIntake: '',
  tobaccoUse: '',
  cessationEducation: '',
  medicalHistory: [],
  lastFluVaccine: '',
  lastPneumoniaVaccine: '',
  prevSurgeries: '',
  patientTB: '',
  familyTB: '',
  followingSymptoms: '',
  bloodTransfusion: '',
  transfusionReactionDetails: '',
  diabetic: '',
  diabeticYears: '',
  diabeticTreatment: '',
  glucometer: '',
  fingerStick: '',
  administerInsulin: '',
  interpreterNeeded: '',
  preferredLanguage: '',
  familyCareInvolved: '',
  familyAvailforTeaching: '',
  educationalNeeds: '',
  response: '',
  motorResponse: '',
  verbalResponse: '',
  affect: '',
  otherAffect: '',
  hearing: '',
  vision: '',
  gagReflex: '',
  speech: '',
  prevSurgeriesDetails: '',
}

// NursesAssessmentForm3 interface and initial state
export interface NursesAssessmentForm3Fields {
  regular: string[]
  irregular: string[]
  strong: string[]
  weak: string[]
  chestPain: string
  chestPainLoc: string
  nailBeds: string
  edemafour: string[]
  edemafourDetails: string
  edemathree: string[]
  edemathreeDetails: string
  edematwo: string[]
  edematwoDetails: string
  edemaone: string[]
  edemaoneDetails: string
  otherCardiovascular: string
  cardianRhythmDetails: string
  clear: string[]
  equalbilaterally: string[]
  course: string[]
  rales: string[]
  rhonchi: string[]
  wheeze: string[]
  pleural: string[]
  otherSoundDetails: string
  cough: string
  coughColor: string
  coughQuality: string
  coughQuantity: string
  nasalFlaring: string
  ett: string
  o2: string
  breathShortness: string
  ettSize: string
  o2Size: string
  edemanone: string
  capillaryRefillOtherDetails: string
  capillaryRefillTime: string
  o2Amount: string
  o2TakenVia: string
}

export const NURSES_ASSESSMENT_FORM3_INITIAL_STATE: NursesAssessmentForm3Fields = {
  regular: [],
  irregular: [],
  strong: [],
  weak: [],
  chestPain: '',
  chestPainLoc: '',
  nailBeds: '',
  edemafour: [],
  edemafourDetails: '',
  edemathree: [],
  edemathreeDetails: '',
  edematwo: [],
  edematwoDetails: '',
  edemaone: [],
  edemaoneDetails: '',
  otherCardiovascular: '',
  cardianRhythmDetails: '',
  clear: [],
  equalbilaterally: [],
  course: [],
  rales: [],
  rhonchi: [],
  wheeze: [],
  pleural: [],
  otherSoundDetails: '',
  cough: '',
  coughColor: '',
  coughQuality: '',
  coughQuantity: '',
  nasalFlaring: '',
  ett: '',
  o2: '',
  breathShortness: '',
  ettSize: '',
  o2Size: '',
  edemanone: '',
  capillaryRefillOtherDetails: '',
  capillaryRefillTime: '',
  o2Amount: '',
  o2TakenVia: '',
}

// NursesAssessmentForm4 interface and initial state
export interface NursesAssessmentForm4Fields {
  lastBMdate: string
  bowelPatterns: string
  bowelSounds: string
  abdomen: string
  abdomenLocation: string
  experiencingGI: string
  urineColor: string
  bladder: string
  catheterType: string
  catheterSize: string
  catheterDate: string
  catheterChange: string
  equal: string[]
  strong: string[]
  weak: string[]
  paralysis: string[]
  spastic: string[]
  contracture: string[]
  flaccid: string[]
  amputation: string[]
  bedMobility: string
  transfers: string
  gait: string
  balance: string
  comprehension: string
  expression: string
  cognition: string
  readingWriting: string
  grooming: string
  feeding: string
  bathing: string
  dressing: string
  assistiveDevices: string[]
  otherassistiveDevices: string
  skinColor: string[]
  skintempreture: string[]
  otherskinTempDetails: string
  turgor: string
  otherTurgorDetails: string
  skinTexture: string
  otherskinTextureDetails: string
  sensory: string
  moisture: string
  activity: string
  mobility: string
  nutrition: string
  friction: string
  skinPrecatuions: string
  woundTeamNotified: string
  diet: string
  dietType: string
  supplements: string
  howOften: string
  restricitons: string
  appetite: string
  tubeFeeding: string
  parentalFeeding: string
  experiencing: string[]
  mucosaIntact: string
  tongueIntact: string
  dentitionIntact: string
  otherdetails: string
  communicationFunction: []
  adlFunction: []
  otherskinDetails: string
}

export const NURSES_ASSESSMENT_FORM4_INITIAL_STATE: NursesAssessmentForm4Fields = {
  lastBMdate: '',
  bowelPatterns: '',
  bowelSounds: '',
  abdomen: '',
  abdomenLocation: '',
  experiencingGI: '',
  urineColor: '',
  bladder: '',
  catheterType: '',
  catheterSize: '',
  catheterDate: '',
  catheterChange: '',
  equal: [],
  strong: [],
  weak: [],
  paralysis: [],
  spastic: [],
  contracture: [],
  flaccid: [],
  amputation: [],
  bedMobility: '',
  transfers: '',
  gait: '',
  balance: '',
  comprehension: '',
  expression: '',
  cognition: '',
  readingWriting: '',
  grooming: '',
  feeding: '',
  bathing: '',
  dressing: '',
  assistiveDevices: [],
  otherassistiveDevices: '',
  skinColor: [],
  skintempreture: [],
  otherskinTempDetails: '',
  turgor: '',
  otherTurgorDetails: '',
  skinTexture: '',
  otherskinTextureDetails: '',
  sensory: '',
  moisture: '',
  activity: '',
  mobility: '',
  nutrition: '',
  friction: '',
  skinPrecatuions: '',
  woundTeamNotified: '',
  diet: '',
  dietType: '',
  supplements: '',
  howOften: '',
  restricitons: '',
  appetite: '',
  tubeFeeding: '',
  parentalFeeding: '',
  experiencing: [],
  mucosaIntact: '',
  tongueIntact: '',
  dentitionIntact: '',
  otherdetails: '',
  communicationFunction: [],
  adlFunction: [],
  otherskinDetails: '',
}
